import _ from 'lodash'
import { useTimeZone } from '@/plugins/time-zone/index'

const COLUMN_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
  DATE_TIME: 'dateTime',
  SERVER_DATE_TIME: 'serverDateTime',
  JSON: 'json',
  TEXT: 'text',
  ARRAY: 'array'
}

export function convertColumnValue (item: any, typeMap: any) {
  const convertFunction = getConvertValueWithColumnTypeFunction(typeMap)
  return _.mapValues(item, convertFunction)
}

function getConvertValueWithColumnTypeFunction (typeMap: any) {
  const { tz } = useTimeZone()
  return (value: any, key: string) => {
    if (_.isNil(value)) {
      return value
    }
    const dataType = _.get(typeMap, key, COLUMN_TYPE.STRING)
    switch (dataType) {
      case COLUMN_TYPE.NUMBER:
        if (_.isString(value)) {
          return Number(_.replace(value, ',', ''))
        }
        break
      case COLUMN_TYPE.DATE_TIME:
        if (_.isString(value) || _.isNumber(value)) {
          return tz.toDate(value)
        }
        break
      case COLUMN_TYPE.SERVER_DATE_TIME:
        if (_.isString(value) || _.isNumber(value)) {
          return tz.l(value)
        }
        break
      case COLUMN_TYPE.JSON:
        if (_.isString(value)) {
          if (_.isEmpty(_.trim(value))) {
            return undefined
          }
          try {
            return JSON.parse(value)
          } catch (e) { }
        }
        break
      case COLUMN_TYPE.ARRAY:
        if (_.isString(value)) {
          if (_.isEmpty(_.trim(value))) {
            return undefined
          }
          return _.chain(value)
            .split(',')
            .map(item => _.trim(item))
            .filter(item => !_.isEmpty(item))
            .value()
        }
    }
    return value
  }
}
